import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NzButtonModule } from 'ant-reset-private/button';
import { NzCheckboxModule } from 'ant-reset-private/checkbox';
import { NzEmptyModule } from 'ant-reset-private/empty';
import { NzI18nModule } from 'ant-reset-private/i18n';
import { NzIconModule } from 'ant-reset-private/icon';
import { NzInputModule } from 'ant-reset-private/input';

import { NzTransferListComponent } from './nz-transfer-list.component';
import { NzTransferSearchComponent } from './nz-transfer-search.component';
import { NzTransferComponent } from './nz-transfer.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NzCheckboxModule,
    NzButtonModule,
    NzInputModule,
    NzI18nModule,
    NzIconModule,
    NzEmptyModule
  ],
  declarations: [NzTransferComponent, NzTransferListComponent, NzTransferSearchComponent],
  exports: [NzTransferComponent]
})
export class NzTransferModule {}
